import { Tab, TabList, Tabs } from "@chakra-ui/react";
import { entityProfileModalColors } from "../entityProfileModal.theme";

export type EntityProfileNavigationSection = {
  label: string;
  subsections: Array<{
    id: string;
    label: string;
  }>;
};

type Props = {
  activeSectionIndex: number;
  activeSubsectionIndex: number;
  onSectionChange: (index: number) => void;
  onSubsectionChange: (index: number) => void;
  sections: EntityProfileNavigationSection[];
};

export default function EntityProfileNavigation(props: Props) {
  const activeSection = props.sections[props.activeSectionIndex];

  return (
    <>
      <Tabs index={props.activeSectionIndex} variant="unstyled" onChange={props.onSectionChange}>
        <TabList
          borderBottom={`1px solid ${entityProfileModalColors.border}`}
          overflowX="auto"
          px={5}
        >
          {props.sections.map((section) => (
            <Tab
              key={section.label}
              _selected={{
                borderBottomColor: entityProfileModalColors.activeMuted,
                color: entityProfileModalColors.activeMuted,
                fontWeight: 600,
              }}
              borderBottom="2px solid transparent"
              borderRadius={0}
              color={entityProfileModalColors.secondaryText}
              flexShrink={0}
              fontSize="15px"
              px={5}
              py={3}
            >
              {section.label}
            </Tab>
          ))}
        </TabList>
      </Tabs>

      <Tabs
        index={props.activeSubsectionIndex}
        variant="unstyled"
        onChange={props.onSubsectionChange}
      >
        <TabList
          bg={entityProfileModalColors.subtleBg}
          borderBottom={`1px solid ${entityProfileModalColors.border}`}
          flexWrap="wrap"
          overflowX="auto"
          px={5}
        >
          {(activeSection?.subsections ?? []).map((subsection) => (
            <Tab
              key={subsection.id}
              _selected={{
                borderBottomColor: entityProfileModalColors.activeMuted,
                color: entityProfileModalColors.activeMuted,
              }}
              borderBottom="2px solid transparent"
              borderRadius={0}
              color={entityProfileModalColors.navigationText}
              flexShrink={0}
              fontSize="14px"
              fontWeight={600}
              minH="34px"
              px={4}
              py={2.5}
            >
              {subsection.label}
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </>
  );
}
